<template>
    <content-layout>
        <template #header>Posters</template>
        <template #description>The film and TV posters in the carousel on the website's home page. Click + to add
            posters (you can pick several at once).</template>

        <el-upload
                :action="rootpath +'/api/image'"
                :headers="headers"
                list-type="picture-card"
                :before-remove="removeImage"
                :multiple="true"
                name="image"
                :on-success="savePoster"
                :file-list="fileList"
                >
            <i class="el-icon-plus"></i>
        </el-upload>
    </content-layout>
</template>

<script>

    import posterAPI from "../mixins/api/posterAPI";
    import imageAPI from "../mixins/api/imageAPI";

    export default {
        name: "Posters",
        mixins: [posterAPI, imageAPI],
        data() {
            return {

                loading: true,

                posters: [],

                rootpath: process.env.VUE_APP_ROOT_API,
                headers: {Authorization: localStorage.getItem('Authorization')},

            }
        },

        computed: {
            // Converts the file list to appropriate format
            fileList: function() {
                let fileList = [];
                for(const poster of this.posters) {
                    fileList = [...fileList, { id: poster._id, name: poster.fileName, url: this.$imgix(poster.fileName, 200)}]
                }
                return fileList;
            }
        },

        beforeMount: async function () {

            await this.getPosters();

        },

        methods: {

            async savePoster(response, file, fileList) {
                try {
                    await this.posterAPI_create(response.fileName);
                    console.log('created');
                } catch (err) {
                    console.log(err);
                }
            },

            async getPosters() {

                this.posters = await this.posterAPI_get_all();

            },

            async removeImage(file, fileList) {
                try {
                    await this.$confirm('Remove this poster from the website?', 'Delete poster', {
                        confirmButtonText: 'Delete',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });
                } catch (cancelled) {
                    return false;
                }
                try {
                    await this.imageAPI_delete(file.name);
                    await this.posterAPI_delete(file.id);
                    console.log('delete succesful');
                } catch (err) {
                    console.log('delete unsuccesful');
                    return false;
                }

            }

        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/site-content/Posters.vue